import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import i18n from '../../../utils/i18n';
import iconBlock from '@adsk/bim360-matrix-react-assets/icon-block.svg';
import iconCheck from '@adsk/bim360-matrix-react-assets/icon-check.svg';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';

const IssueTypesAdminStatus = props => {
  const isContainerType = props.isContainerType;
  const label = isContainerType
    ? '-'
    : props.isActive
      ? i18n.t('issueTypes.statuses.active')
      : i18n.t('issueTypes.statuses.inactive');
  const icon = props.isActive ? iconCheck : iconBlock;
  const className = cx('IssueTypesAdminStatus', {
    'IssueTypesAdminStatus--disabled': props.disabled,
    'IssueTypesAdminStatus--active': !props.disabled && props.isActive,
    'IssueTypesAdminStatus--inactive': !props.disabled && !props.isActive
  });

  return (
    <div className={className}>
      {!isContainerType && (
        <SvgIcon width="16px" height="16px">
          {icon}
        </SvgIcon>
      )}
      <span className="IssueTypesAdminStatus__label">{label}</span>
    </div>
  );
};

IssueTypesAdminStatus.displayName = 'IssueTypesAdminStatus';

IssueTypesAdminStatus.defaultProps = {
  disabled: false,
  isContainerType: false
};

IssueTypesAdminStatus.propTypes = {
  isActive: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  isContainerType: PropTypes.bool
};

export default IssueTypesAdminStatus;
